import { Spinner } from './Spinner.jsx';

export default Spinner;
